import { z } from 'zod';
import { unitSchema } from './unit.js';
/**
 * 1C BIRLIGINI ODAM O'ZI MOS KELTIRADI.
 *
 * Tizimdagi o'lchov birliklari ro'yxati QISQA va o'zgarmas: dona, kg, metr
 * va yana bir nechtasi. Ularga qoidalar osilgan — yarim dona bo'lmaydi,
 * etiketkada yorlig'i chiqadi — shuning uchun yangi birlik O'YLAB
 * TOPILMAYDI.
 *
 * 1C tomonda esa aksincha: u yerda birlik erkin matn va u cheksiz ko'p
 * ko'rinishda yoziladi (`шт`, `дона(кадок)`, `шт (упаковка)`, `п/м`).
 * Shuning uchun bu yerda saqlanadigan narsa yangi birlik emas, balki
 * XOM MATNNI mavjud birlikka ulagan ip.
 *
 * Nega kodda emas, bazada: har yangi yozuvni dasturchi qo'shadigan bo'lsa,
 * bitta omborning bitta oyi tufayli hisobot ertagacha kutib turardi.
 * Skladchi esa buni o'zi, yuklash oynasining ichida hal qiladi.
 */
export const unitAliasSchema = z.object({
    id: z.string(),
    /** 1C yozgani, O'ZGARTIRILMAGAN holda — qog'ozda shu ko'rinadi. */
    raw: z.string(),
    /** Qidirish kaliti: kichik harf, ortiqcha bo'shliqsiz (`normalizeUnitRaw`). */
    key: z.string(),
    unit: unitSchema,
    createdAt: z.string(),
});
export const createUnitAliasSchema = z.object({
    raw: z.string().trim().min(1).max(60),
    unit: unitSchema,
});
/**
 * Fayldagi TANILMAGAN birlik — yuklash oynasi shu ro'yxat bo'yicha so'raydi.
 *
 * Satr emas, BIRLIK bo'yicha guruhlanadi: bitta `дона(кадок)` beshta satrni
 * to'xtatib turgan bo'lsa, odamdan ham bir marta so'raladi, besh marta
 * emas. `rowCount` esa javobning og'irligini ko'rsatadi — bitta satrmi
 * yoki yuztami.
 */
export const unknownUnitSchema = z.object({
    raw: z.string(),
    rowCount: z.number().int(),
    /** Birinchi uchragan satr — odam faylda topib, o'z ko'zi bilan ko'radi. */
    sheetRow: z.number().int(),
    /** Misol uchun bitta material nomi — «bu nima edi?» degan savolga javob. */
    sampleName: z.string().nullable(),
});
//# sourceMappingURL=unit-alias.schema.js.map